const SIDEBAR = 'section.sidebar li';
const CONFIG_SIDEBAR = 'div.leftPane.config-sidebar li';
const CONTAINER_INNER = 'section.container-sb';
const ACTIVE = 'active';
const FIRST_LI = 'li:first';
const V3_WRAPPER = '.v3Wrapper';
const V4_WRAPPER = '.v4Wrapper';

class HostNavigatorService {
	get hostElement() {
		return this.element;
	}

	get isJQueryObject() {
		return this.element instanceof jQuery;
	}

	/**
	 * 
	 * @param {*} element $element 혹은 host element를 넘겨야 합니다.
	 */
	constructor() {
		this._element = null;
		this._id = null;
		this._listeners = {};
		this._watchers = [];

		$(window).on('beforeunload', () => {
			for (let id in this._listeners) {
				delete this._listeners[id];

			}
			this._listeners = null;
		})
	}

	init(element, id, callback) {
		this._element = element;
		this._id = id;

		if (callback && !this._listeners[this._id]) {
			this._listeners[this._id] = callback;
		}
	}

	configRouter(elem, id, event, href, index) {
		return new Promise((resolve, reject) => {
			try {
				let element = elem;
				if (!this.isJQueryObject) {
					element = $(element);
				}

				if (index != null) {
					if(id == 'config') {
						const configSidebar = element.find(CONFIG_SIDEBAR);
						configSidebar.eq(index).addClass(ACTIVE);
					}
				} else {
					if (!event || !event.target) {
						const leftPane = element[0].querySelector('.leftPane');
						if (leftPane){
							const target = leftPane.querySelector(`[menu-name="${href}"`);
							$(target).addClass(ACTIVE);
						}
					} else {
						$(event.target).parents(FIRST_LI).addClass(ACTIVE);
					}
				}

				element.children(V4_WRAPPER).hide();
				element.find(V3_WRAPPER).show();
				element.children(CONTAINER_INNER).hide();
				element.find(href).show();

				resolve(href);
			} catch (e) {
				reject(e);
			} finally {
			}
		})
	}
	go(elem, event, href, index) {
		return new Promise((resolve, reject) => {
			try {
				let element = elem;
				if (!this.isJQueryObject) {
					element = $(element);
				}

				const sidebar = element.find(SIDEBAR);
				sidebar.removeClass(ACTIVE);

				if (index != null) {
					// index가 있는 경우에는 부모의 sidebar li의 index번째에 해당하는 곳에 active 적용
					sidebar.eq(index).addClass(ACTIVE);
				} else {
					// event.target은 iframe내의 li를 가리킴
					// 따라서 부모의 li에 active를 주기 위해서 내가 클릭한 곳의 li의 index를 가져와서 부모 list에 적용해야 함
					$(event.target).parents(FIRST_LI).addClass(ACTIVE);
				}

				element.children(CONTAINER_INNER).hide();
				element.find(href).show();
				resolve(href);
			} catch (e) {
				reject(e);
			} finally {
				for (let id in this._listeners) {
					const callback = this._listeners[id];
					if (callback && typeof callback === 'function') {
						callback(href);
					}
				}
				
				this._watchers.forEach((callback) => callback(href));
			}
		})
	}

	
	// v4에서는 기존에 사용하던것과 다르게 init을 할수 없기 때문에 별도로 watch를 사용해 상태를 관찰 할 수 있음
	/**
	 * callback으로 Href 값을 받아올 수있습니다.
	 * @callback watch
	 * @param {string} href - 이동하는 href
	 */
	/**
	 * hostNavigator에서 소메뉴 이동시 상태를 관찰합니다.
	 * @param {watch} callback
	 * @return {id}
	 */
	watch(callback) {
		this._watchers.push(callback);
		return this._watchers.length -1;
	}

	unwatch(id) {
		this._watchers.splice(id, 1);
	}

	unsubscribe(id) {
		if (this._listeners[id]) {
			delete this._listeners[id];
		}
	}

	unsubscribeAll() {
		for (let id in this._listeners) {
			this.unsubscribe(id);
		}
	}
}

export default HostNavigatorService;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/core/HostNavigatorService.js